import { apiServer } from 'settings/web-services/api';

export function getUserRelatedContacts(cfg) {
  return apiServer.get('/workshop/transaction/related-contacts', { params: cfg });
}
